import axios from "axios";
import _ from "lodash";

import getVar from "constants/.";
import store from "./reduxStore";
import packageJson from "../package.json";

export const localRequest = axios.create({
  baseURL: getVar("LOCAL_API_URI"),
});

localRequest.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const accessToken = _.get(state, "app.user.access_token", "");

    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export const configurationsFromFile = () =>
  new Promise((resolve, reject) => {
    const req = new XMLHttpRequest();
    req.open("GET", "/server-config.json", true);
    req.onload = function () {
      try {
        const newConfigs = JSON.parse(this.responseText);
        for (const [envConfig, newValue] of Object.entries(newConfigs)) {
          // @ts-ignore
          localStorage.setItem(envConfig, newValue.toString());
        }
        resolve(newConfigs);
      } catch (e) {
        reject(e.message);
        console.log("Unable to load configuration file", e.message);
      }
    };
    req.send();
  });

export const setBaseUrl = () => {
  (axios as any).defaults.baseURL = getVar("CAPI_URL");
};

export const compareAppVersionsAndClearLocalStorageIfDifferent = () => {
  const currentApplicationVersion =
    localStorage.getItem("applicationVersion") || "1";
  const customer = localStorage.getItem("customer");
  const userName = localStorage.getItem("userName");
  const newApplicationVersion = packageJson.version;

  if (currentApplicationVersion !== newApplicationVersion) {
    localStorage.clear();
    localStorage.setItem("applicationVersion", newApplicationVersion);
    // set customer data so the user does not have to select his company on login
    if (customer) {
      localStorage.setItem("customer", customer);
    }
    if (userName) {
      localStorage.setItem("userName", userName);
    }
  }
};

axios.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const accessToken = _.get(state, "app.user.access_token", "");
    const name = _.get(state, "app.user.profile.name", "");
    const userName = _.get(state, "app.userName", null);

    config.headers.Authorization = `Bearer ${accessToken}`;
    if (userName === name) {
      config.headers.CustomerId = _.get(state, "app.currentCustomer.Id", "");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => {
    // return _.get(response, "data", response);
    return response;
  },
  (error) => Promise.reject(error)
);
